import { adminGet } from "../../http";
import { SettingConfigData } from "../../../types/Setting/SettingConfigData";

export const searchWebImage = async (
  query: string,
  config: SettingConfigData | null
): Promise<{ link_url: string; thumbnail_url: string }[]> => {
  return adminGet(
    "announcements/web_image_search",
    { query: query },
    { requireUser: true, config }
  );
};
